export default __webpack_public_path__ + "static/media/option-4.6d9060db.svg";